import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import UserService from "../../services/user.service";

/**
 * Select from curated titles managed by super admin.
 */
const TitleCombobox = ({
  value,
  onChange,
  onBlur,
  name = "title",
  className,
  controlId = "title",
  label = "Title",
  showLabel = true,
  disabled = false,
}) => {
  const [titles, setTitles] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const list = await UserService.getUserTitles();
        if (!cancelled) setTitles(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error(err);
        if (!cancelled) setTitles([]);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const current = (value ?? "").toString();
  const options = [...titles];
  // Keep legacy / removed titles visible so existing users aren't blanked out
  if (current && !options.includes(current)) {
    options.unshift(current);
  }

  return (
    <Form.Group className="mb-3" controlId={controlId}>
      {showLabel && <Form.Label>{label}</Form.Label>}
      <Form.Select
        name={name}
        value={current}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
        disabled={disabled}
      >
        <option value="">— Select a title —</option>
        {options.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </Form.Select>
      {showLabel && (
        <Form.Text className="text-muted">
          Titles are managed by a super admin.
        </Form.Text>
      )}
    </Form.Group>
  );
};

export default TitleCombobox;
